import React from "react";
import { Typography, Link } from "@mui/material";
import { COVERAGE_STATES } from "../../../constants";
import { DataGrid } from "@mui/x-data-grid";
import { ANNoResultsOverlay, ANTooltip } from "@answersnow/pkg-theme";

const InsuranceTable = (props) => {
  const {
    insurancePlansData,
    isFetchingData,
    setDataPanel,
    updateTitlePanel,
    setIsPanelOpen,
    isPanelOpen,
    setEditMode,
    paginationModel,
    setPaginationModel,
    rowCount,
    setPlanFilter,
    setCompanyFilter,
    setCoverageStateFilter,
    setOpenWarning,
    unsavedChanges,
  } = props;

  const handleSelect = (row) => {
    if (isPanelOpen) {
      if (unsavedChanges) {
        setOpenWarning(true);
      } else {
        setEditMode(true);
        updateTitlePanel(null);
        setIsPanelOpen(false);
        setDataPanel([]);
        setIsPanelOpen(false);
      }
    } else {
      setEditMode(false);
      updateTitlePanel(row.name);
      setIsPanelOpen(true);
      setDataPanel({ ...row });
      setIsPanelOpen(true);
    }
  };
  const getColumnDefinitions = (handleSelect) => {
    const defaultColAttrs = { sortable: false, flex: 1 };

    const columns = [
      {
        field: "name",
        headerName: "Insurance Plan",
        ...defaultColAttrs,
        renderCell: (params) => {
          return (
            <ANTooltip
              component={Link}
              style={{ maxWidth: "100%", display: "block" }}
              onClick={(e) => handleSelect(params)}
              underline={"hover"}
            >
              {params.value}
            </ANTooltip>
          );
        },
      },
      { field: "insurance_name", headerName: "Insurance Company", ...defaultColAttrs },
      {
        field: "address",
        headerName: "Address",
        ...defaultColAttrs,
        renderCell: (params) => {
          const address = [
            `${params.row.address_1?.trim()}${params.row.address_2 ? " " + params.row.address_2?.trim() : ""} `,
            `${params.row.city?.trim()}, ${params.row.state} ${params.row.zip}`,
          ];
          return (
            <ANTooltip
              component={Typography}
              variant="body2"
              style={{ maxWidth: "100%", display: "block" }}
            >
              {address}
            </ANTooltip>
          );
        },
      },
      {
        field: "coverage_state",
        headerName: "Coverage State",
        ...defaultColAttrs,
        renderCell: (params) => {
          return <Typography variant="body2">{COVERAGE_STATES[params.value]}</Typography>;
        },
      },
    ];
    return columns;
  };

  const handleClearFilters = () => {
    setPlanFilter([]);
    setCompanyFilter([]);
    setCoverageStateFilter([]);
  };

  const customNoRowsOverlay = {
    NoResults: {
      component: ANNoResultsOverlay,
      height: "236px",
      props: { handleClearFilters },
    },
  };
  const overlayName = "NoResults";

  return (
    <DataGrid
      rows={insurancePlansData}
      loading={isFetchingData && !batchFiles}
      pageSizeOptions={[5, 10, 20]}
      columns={getColumnDefinitions(({ row }) => handleSelect(row))}
      onRowClick={(params) => handleSelect(params.row)}
      paginationModel={paginationModel}
      onPaginationModelChange={setPaginationModel}
      slots={{
        noRowsOverlay: customNoRowsOverlay[overlayName].component,
      }}
      slotProps={{ noRowsOverlay: { ...customNoRowsOverlay[overlayName].props } }}
      sx={{
        "--DataGrid-overlayHeight": customNoRowsOverlay[overlayName].height,
        "& .MuiDataGrid-selectedRowCount": { visibility: "hidden" },
      }}
      hideFooter={!rowCount}
      paginationMode="server"
      rowCount={rowCount}
      disableSelectionOnClick
    />
  );
};

export default InsuranceTable;
